module.exports = __webpack_public_path__ + "static/media/S8.7247ed43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assests/images/S8.png
// module id = 129
// module chunks = 0